import { createRouter, createWebHashHistory } from "vue-router";
// 公共
import Home from "@/common/Home";
import NotFound from "@/views/404";
import Login from "@/views/Login";
import Index from "@/views/Index";
// V策财经0
import BusinessDynamic from "@/views/vce/BusinessDynamic";
import Chat from "@/views/vce/Chat";
import ChatNew from "@/views/vce/ChatNew";
import MarketEditor from "@/views/vce/MarketEditor";
import EnterpriseWechat from "@/views/vce/EnterpriseWechat";
import ArticleTemplate from "@/views/vce/ArticleTemplate";
import Dummy from "@/views/vce/Dummy";
import Statistics from "@/views/vce/Statistics";
import PushMessage from "@/views/vce/PushMessage";
import RiskPush from "@/views/vce/RiskPush";
import Bbas from "@/views/vce/Bbas";
import TechnicalModel from "@/views/vce/TechnicalModel";
import TechnicalModelModify from "@/views/vce/TechnicalModelModify";
import HeadlineReport from "@/views/vce/HeadlineReport";
import HeadlineReportCategory from "@/views/vce/HeadlineReportCategory";
import ViewingData from "@/views/vce/ViewingData";
import StrategyList from "@/views/vce/StrategyList";
import QiyouCommunity from "@/views/vce/QiyouCommunity";
import BlackResearchReport from "@/views/vce/BlackResearchReport";
import Qihuoshangpin from "@/views/vce/Qihuoshangpin";
import Nongchanpin from "@/views/vce/Nongchanpin";
import Yousejinshu from "@/views/vce/Yousejinshu";
import liveCategory from "@/views/vce/live/category";
import liveVideo from "@/views/vce/live/video";
import LiveAssistant from "@/views/vce/LiveAssistant";
import Information from "@/views/vce/Information";
import DouyinPictureCategory from "@/views/vce/douyinPicture/category";
import DouyinPictureList from "@/views/vce/douyinPicture/list";
import LuckyBagRain from "@/views/vce/raffle/LuckyBagRain";
import DrawPrize from "@/views/vce/raffle/DrawPrize";
// 正信1
import BandOpportunity from "@/views/zhengxin/BandOpportunity";
// 新湖4
import VarietyTracking from "@/views/xinhu/VarietyTracking";
import DiscoverVideo from "@/views/xinhu/DiscoverVideo";
// 东海6
import ShortStrategy from "@/views/donghai/ShortStrategy";
import TrendFollowing from "@/views/donghai/TrendFollowing";
import TrendFollowingList from "@/views/donghai/TrendFollowingList";

import CompanyCircle from "@/views/CompanyCircle";
import CircleManage from "@/views/CircleManage";

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/",
    component: Home,
    children: [
      {
        path: "/businessDynamic",
        component: BusinessDynamic,
        meta: { title: "交易动态" },
        companyIds: [0],
      },
      {
        path: "/articleTemplate",
        component: ArticleTemplate,
        meta: { title: "文章模板" },
        companyIds: [0],
      },
      {
        path: "/chat",
        component: Chat,
        meta: { title: "聊天" },
        companyIds: [0],
      },
      {
        path: "/chatNew",
        component: ChatNew,
        meta: { title: "聊天(内测版)" },
        companyIds: [0],
      },
      {
        path: "/marketEditor",
        component: MarketEditor,
        meta: { title: "行情编辑" },
        companyIds: [0],
      },
      // {
      //   path: "/enterpriseWechat",
      //   component: EnterpriseWechat,
      //   meta: { title: "企业微信" },
      // },
      {
        path: "/dummy",
        component: Dummy,
        meta: { title: "假人管理" },
        companyIds: [0],
      },
      {
        path: "/circleManage",
        component: CircleManage,
        meta: { title: "圈子管理" },
        companyIds: [0, 1, 4, 6],
      },
      {
        path: "/statistics",
        component: Statistics,
        meta: { title: "统计数据" },
        companyIds: [0],
      },
      {
        path: "/pushMessage",
        component: PushMessage,
        meta: { title: "推送消息" },
        companyIds: [0],
      },
      {
        path: "/bbas",
        component: Bbas,
        meta: { title: "多空情报" },
        companyIds: [0],
      },
      // {
      //   path: "/riskPush",
      //   component: RiskPush,
      //   meta: { title: "风险推送" },
      // },
      {
        path: "/technicalModel",
        component: TechnicalModel,
        meta: { title: "技术案例模型" },
        companyIds: [0],
      },
      {
        path: "/technicalModelModify",
        component: TechnicalModelModify,
        meta: { title: "技术案例模型" },
        companyIds: [0],
      },
      {
        path: "/headlineReport",
        component: HeadlineReport,
        meta: { title: "头条报告" },
        companyIds: [0],
      },
      {
        path: "/headlineReportCategory",
        component: HeadlineReportCategory,
        meta: { title: "头条报告" },
        companyIds: [0],
      },
      {
        path: "/viewingData",
        component: ViewingData,
        meta: { title: "看数据" },
        companyIds: [0],
      },
      {
        path: "/companyCircle",
        component: CompanyCircle,
        meta: { title: "圈子" },
        companyIds: [1, 4, 6],
      },
      {
        path: "/strategyList",
        component: StrategyList,
        meta: { title: "策略列表" },
        companyIds: [0],
      },
      {
        path: "/varietyTracking",
        component: VarietyTracking,
        meta: { title: "品种追踪列表" },
        companyIds: [4],
      },
      {
        path: "/shortStrategy",
        component: ShortStrategy,
        meta: { title: "短线跟踪列表" },
        companyIds: [6],
      },
      {
        path: "/trendFollowing",
        component: TrendFollowing,
        meta: { title: "趋势跟踪" },
        companyIds: [6],
      },
      {
        path: "/trendFollowingList",
        component: TrendFollowingList,
        meta: { title: "趋势跟踪列表" },
        companyIds: [6],
      },
      {
        path: "/qiyouCommunity",
        component: QiyouCommunity,
        meta: { title: "期友社区" },
        companyIds: [0],
      },
      {
        path: "/bandOpportunity",
        component: BandOpportunity,
        meta: { title: "波段机会" },
        companyIds: [1],
      },
      {
        path: "/blackResearchReport",
        component: BlackResearchReport,
        meta: { title: "黑色系研报" },
        companyIds: [0],
      },
      {
        path: "/qihuoshangpin",
        component: Qihuoshangpin,
        meta: { title: "期货商品" },
        companyIds: [0],
      },
      {
        path: "/nongchanpin",
        component: Nongchanpin,
        meta: { title: "农产品研报" },
        companyIds: [0],
      },
      {
        path: "/yousejinshu",
        component: Yousejinshu,
        meta: { title: "有色金属研报" },
        companyIds: [0],
      },
      {
        path: "/yousejinshu",
        component: Yousejinshu,
        meta: { title: "有色金属研报" },
        companyIds: [0],
      },
      {
        path: "/live/category",
        component: liveCategory,
        meta: { title: "分类管理" },
        companyIds: [0],
      },
      {
        path: "/live/video",
        component: liveVideo,
        meta: { title: "视频管理" },
        companyIds: [0],
      },
      {
        path: "/liveAssistant",
        component: LiveAssistant,
        meta: { title: "直播助手" },
        companyIds: [0],
      },
      {
        path: "/information",
        component: Information,
        meta: { title: "快讯列表" },
        companyIds: [0],
      },
      {
        path: "/discoverVideo",
        component: DiscoverVideo,
        meta: { title: "发现·视频" },
        companyIds: [4],
      },
      {
        path: "/douyinPicture/category",
        component: DouyinPictureCategory,
        meta: { title: "抖音新箱图分类管理" },
        companyIds: [0],
      },
      {
        path: "/douyinPicture/list",
        component: DouyinPictureList,
        meta: { title: "抖音新箱图" },
        companyIds: [0],
      },
      {
        path: "/raffle/luckyBagRain",
        component: LuckyBagRain,
        meta: { title: "红包雨活动" },
        companyIds: [0],
      },
      {
        path: "/raffle/drawPrize",
        component: DrawPrize,
        meta: { title: "直播间抽奖" },
        companyIds: [0],
      },
    ],
  },
  {
    path: "/index",
    name: "index",
    component: Index,
    meta: { title: "V策财经研究员管理系统" },
    companyIds: [0, 1, 4, 6],
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { title: "V策财经研究员管理系统" },
    companyIds: [0, 1, 4, 6],
  },
  {
    path: "/404",
    name: "404",
    component: NotFound,
    meta: { title: "V策财经研究员管理系统" },
    companyIds: [0, 1, 4, 6],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "404",
    component: NotFound,
    meta: { title: "V策财经研究员管理系统" },
    companyIds: [0, 1, 4, 6],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
